import React from "react"
import type { ComponentType } from "react"
import type { PreviewData, ViewerProps } from "@/lib/types"

const Viewer = React.lazy<ComponentType<ViewerProps>>(() =>
  import("@/components/Viewer").then((module) => ({ default: module.Viewer })),
)

interface PreviewViewerProps {
  preview: PreviewData
  SubPreview?: PreviewData | null
}

export function PreviewViewer({ preview, SubPreview }: PreviewViewerProps) {
  return (
    <div className="h-screen rounded-xl flex items-center justify-center overflow-hidden p-0">
      <Viewer
        PreviewObj={preview}
        SubPreviewObj={SubPreview}
        preserveDrawingBuffer={true}
        autoRotate={true}
      />
    </div>
  )
}
